import { Box, Stack } from '@ff-it/ui';
import { AgencyActivityTypesField } from 'components';
import { CompanyField } from 'modules/core/company/components';
import { ReactElement, ReactNode } from 'react';

export type GroupFieldsProps = {
  name: string;
};

function InlineField({ label, children }: { label: ReactNode; children: ReactNode }): ReactElement {
  return (
    <Stack direction="horizontal" space="2" align="center" style={{ minWidth: '250px', height: '38px' }}>
      <Box as="label" mb="0" textSize="sm" color="gray700">
        {label}
      </Box>
      {children}
    </Stack>
  );
}

export function AVBGroupFields({ name }: GroupFieldsProps): ReactElement {
  return (
    <Stack direction="horizontal" space="4" align="center">
      <InlineField label="Provider *">
        <CompanyField
          name={`${name}.provider`}
          includeBranches={true}
          required
          className="mb-0 flex-grow-1"
          placeholder="All"
          size="sm"
        />
      </InlineField>
      <InlineField label="Type">
        <AgencyActivityTypesField name={`${name}.type`} className="mb-0 flex-grow-1" placeholder="All" />
      </InlineField>
    </Stack>
  );
}
export function CVBGroupFields({ name }: GroupFieldsProps): ReactElement {
  return (
    <Stack direction="horizontal" space="4" align="center">
      <InlineField label="Client">
        <CompanyField
          name={`${name}.client`}
          includeBranches={true}
          required
          className="mb-0 flex-grow-1"
          placeholder="All"
          size="sm"
        />
      </InlineField>
      <InlineField label="Payer">
        <CompanyField
          name={`${name}.payer`}
          includeBranches={true}
          required
          className="mb-0 flex-grow-1"
          placeholder="All"
          size="sm"
        />
      </InlineField>
      <InlineField label="Type">
        <AgencyActivityTypesField name={`${name}.type`} className="mb-0 flex-grow-1" placeholder="All" />
      </InlineField>
    </Stack>
  );
}
